import { ReactNode } from 'react';
import { Container, Box } from '@mui/material';
import { ErrorsStack } from '../ErrorsStack';
import Title from './Title';
import style from './style';

type Props = {
  title?: {
    text: string,
    icon?: ReactNode,
  },
  children: ReactNode;
  errors?: string | string[],
}

export default function ListPageContainer({
  children, errors, title,
}: Props): JSX.Element {
  const renderErrors = () => {
    if (!errors) {
      return null;
    }

    return (
      <ErrorsStack
        errors={ Array.isArray(errors) ? errors : [] }
        errorMessage={ !Array.isArray(errors) ? errors : '' }
      />
    );
  };

  return (
    <Container maxWidth={ style.container.maxSize } sx={ style.paddings.pt64 } >
      <Box sx={ { ...style.box, ...style.boxMain } }>
        { title && <Title text={ title.text } icon={ title.icon } /> }
      </Box>
      { renderErrors() }
      <Box sx={ style.card.sx }>
        {children}
      </Box>
    </Container>
  );
}

ListPageContainer.defaultProps = {
  title: undefined,
  errors: undefined,
};
